module.exports = __webpack_public_path__ + "static/media/map-signs.3003efe5.svg";